import { render, staticRenderFns } from "./coloursLinkHouse.vue?vue&type=template&id=72ba847a"
import script from "./coloursLinkHouse.vue?vue&type=script&lang=js"
export * from "./coloursLinkHouse.vue?vue&type=script&lang=js"
import style0 from "./coloursLinkHouse.vue?vue&type=style&index=0&id=72ba847a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports